import { useGlobalState } from 'context/GlobalStateContext'
import { useGetCasTypesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { CASTypesContext } from './types'

const { Provider, useContextFn } =
  createStrictContext<CASTypesContext>('CASTypesContext')

export const useCASTypesContext = useContextFn

export const TypesTableProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, refetch, loading } = useGetCasTypesQuery({
    ...DefaultQueryHookOptions,
    variables: { casTypeListInput: { projectId: { equals: projectId } } },
  })
  return (
    <Provider
      value={{ records: data?.casTypes?.records ?? [], refetch, loading }}
    >
      {children}
    </Provider>
  )
}
